import { AcreFeetEditCell, GpyEditCell } from "./AcreFeetGpyEditCell";

export const PERMITS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/permits-management`;
export const LIST_CONTACT_NAME = `${PERMITS_BASE_URL}/list-contact-name`;
export const LIST_MONTHLY_ALLOCATION_PROFILE = `${PERMITS_BASE_URL}/list-monthly-allocation-profile`;
export const PERMIT_PK_FIELD = "permit_ndx";

export const COLUMNS = [
  {
    field: "permit_ndx",
    headerName: "Permit",
    width: 100,
    editable: false,
    type: "number",
  },
  {
    field: "permit_nickname",
    headerName: "Permit Nickname",
    minWidth: 200,
    editable: true,
  },
  {
    field: "assoc_contact_ndx",
    headerName: "Contact",
    minWidth: 200,
    editable: true,
    type: "number",
  },
  { field: "assoc_well_ndx", headerName: "Wells", width: 200, editable: true },
  {
    field: "assoc_drought_zone_ndx",
    headerName: "Drought Zone",
    minWidth: 200,
    editable: true,
    type: "number",
  },
  {
    field: "dt_permitted",
    headerName: "Date Permitted",
    width: 150,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "dt_expiration",
    headerName: "Expiration Date",
    width: 150,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "id_permit_legacy",
    headerName: "Legacy IDs",
    width: 150,
    editable: true,
  },
  {
    field: "permit_acre_feet",
    headerName: "Acre-Feet",
    width: 120,
    editable: true,
    type: "number",
    renderEditCell: (params) => <AcreFeetEditCell {...params} />,
  },
  {
    field: "permit_gpy",
    headerName: "GPY",
    width: 100,
    editable: true,
    type: "number",
    renderEditCell: (params) => <GpyEditCell {...params} />,
  },
  {
    field: "allocation_profile_ndx",
    headerName: "Allocation Profile",
    minWidth: 280,
    editable: true,
    type: "number",
  },
  {
    field: "req_wl_reporting",
    headerName: "Water Level Reporting",
    width: 180,
    editable: true,
    type: "boolean",
  },
  {
    field: "is_active",
    headerName: "Active",
    width: 110,
    editable: true,
    type: "boolean",
  },
  {
    field: "has_connections",
    headerName: "Has Additional Connections",
    width: 200,
    editable: true,
    type: "boolean",
  },
];
